import { BaseService } from "./../base";
export class ProfessionService extends BaseService {
  static get entity() {
    return "profession";
  }
  static get name() {
    return "profession";
  }
}
